import { BarberEmployee, Service } from "../../Model";
import { AdminBarberRepository } from "../../Repository";

export async function addBarberEmployee(
  employee: BarberEmployee,
  repository: AdminBarberRepository
): Promise<boolean> {
  return repository.addBarberEmployee(employee);
}
